<div class ='pair-usa-box'>

	<div id='g-USmap-box' class='ai2html'>
		<!-- Generated by ai2html v0.59 - 2016-12-20 - 10:54 -->
		<!-- ai file: USmap -->
		<!-- Artboard: Artboard_1 -->
		<h2 class='pair-headline' >In 2015, there were more than 13,000 gun homicides throughout the US …</h2>
		<div id='g-USmap-Artboard_1' class='g-artboard first-artboard' data-min-width='1505'>
			<div id='g-USmap-Artboard_1-graphic'>
				<img id='g-ai0-0'
					class='g-aiImg all-dots'
					src='<@baseUrl@>/<@version@>/files/images/USmap-Artboard_1.png'
					/>
				<div id='g-ai0-7' class='g-Labels g-aiAbs' style='top:27.8368%;left:85.0513%;'>
					<p class='g-aiPstyle0'>New York</p>
				</div>
				<div id='g-ai0-10' class='g-Labels g-aiAbs' style='top:35.4347%;right:32.4986%;'>
					<p class='g-aiPstyle1'>Chicago</p>
				</div>
				<div id='g-ai0-11' class='g-Labels g-aiAbs' style='top:34.8485%;right:86.8802%;'>
					<p class='g-aiPstyle1'>Oakland</p>
				</div>
				<div id='g-ai0-13' class='g-Labels g-aiAbs' style='top:42.8712%;left:82.6638%;'>
					<p class='g-aiPstyle0'>Baltimore</p>
				</div>
				<div id='g-ai0-18' class='g-Labels g-aiAbs' style='top:48.3742%;left:62.9801%;'>
					<p class='g-aiPstyle0'>St Louis</p>
				</div>
				<div id='g-ai0-26' class='g-Labels g-aiAbs' style='top:79.1774%;left:63.1064%;'>
					<p class='g-aiPstyle0'>New Orleans</p>
				</div>
			</div>
		</div>
		<!-- End ai2html - 2016-12-20 - 10:54 -->
	</div>

	<div id='g-USmap-box' class='ai2html'>
		<!-- Generated by ai2html v0.59 - 2016-12-20 - 10:54 -->
		<!-- ai file: USmap -->
		<!-- Artboard: Artboard_1 -->
		<h2 class='pair-headline' >… but <span class='gia-underline-high'>half</span> of those deaths were in just 127 cities, which contain almost a <span class='gia-underline-low'>quarter</span> of the population</h2>
		<div id='g-USmap-Artboard_1' class='g-artboard ' data-min-width='1505'>
			<div id='g-USmap-Artboard_1-graphic'>
				<img id='g-ai0-0'
					class='g-aiImg all-dots'
					src='<@baseUrl@>/<@version@>/files/images/USmap-Artboard_2.png'
					/>
				<div id='g-ai0-7' class='g-Labels g-aiAbs' style='top:27.8368%;left:85.0513%;'>
					<p class='g-aiPstyle0'>New York</p>
				</div>
				<div id='g-ai0-10' class='g-Labels g-aiAbs' style='top:35.4347%;right:32.4986%;'>
					<p class='g-aiPstyle1'>Chicago</p>
				</div>
				<div id='g-ai0-11' class='g-Labels g-aiAbs' style='top:34.8485%;right:86.8802%;'>
					<p class='g-aiPstyle1'>Oakland</p>
				</div>
				<div id='g-ai0-13' class='g-Labels g-aiAbs' style='top:42.8712%;left:82.6638%;'>
					<p class='g-aiPstyle0'>Baltimore</p>
				</div>
				<div id='g-ai0-18' class='g-Labels g-aiAbs' style='top:48.3742%;left:62.9801%;'>
					<p class='g-aiPstyle0'>St Louis</p>
				</div>
				<div id='g-ai0-26' class='g-Labels g-aiAbs' style='top:79.1774%;left:63.1064%;'>
					<p class='g-aiPstyle0'>New Orleans</p>
				</div>
			</div>
		</div>
		<!-- End ai2html - 2016-12-20 - 10:54 -->
	</div>

</div>

<style>

.gia-underline-low {
	border-bottom: 2px #c05303 solid;
	padding-bottom: 1px;
}

.gia-underline-high {
	border-bottom: 2px #c05303 solid;
}

.pair-headline {
	min-height: 72px;
	font-size: 24px;
}

.pair-usa-box {
	margin: 70px 0;
}
.pair-usa-box::after {
    display: table;
    content: '';
    clear: both;
}

.g-artboard {
	margin:0 auto;
}

#g-USmap-box {
	width: 50%;
	float: left;
}

#g-USmap-Artboard_1{
	position:relative;
	overflow:hidden;
}

.g-aiAbs{
	position:absolute;
}

.g-aiImg{
	display:block;
	width:100% !important;
}

.g-aiPtransformed p { white-space: nowrap; }

.g-aiPstyle0, .g-aiPstyle1 {
	font-size: 14px;
    font-family: 'Guardian Text Sans Web';
    text-shadow: 2px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;

}

.g-aiPstyle0 {
	text-align: left;
}

.g-aiPstyle1 {
	text-align: right;
}

@media(max-width:800px) {

	#g-USmap-box  {
		width: 100%;
	}

	.first-artboard {
		margin-bottom: 20px;
	}

}

@media(max-width:600px) {

	.g-aiPstyle0, .g-aiPstyle1 {
		font-size: 12px;
		line-height: 10px;
	}

}

@media(max-width:450px) {
	.g-aiPstyle0, .g-aiPstyle1  {
		display: none;
	}
}

@media(min-width:750px) {
	.pair-headline {
		margin-left: 35px;
}

</style>

<script>


export default {
	data () {
		return {


		}
	}

};
</script>
